import React from 'react';
import { useTranslation } from "react-i18next";
import { useAuth } from '../../../context/AuthContext';
import Swal from 'sweetalert2';
import axios from "axios";
const GeneralProfile = () => {
    const { t } = useTranslation();
    const { user } = useAuth();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const headerss = {
                "accept": "*/*",
                "Content-Type": "application/json",
                "Access-Control-Allow-Credentials": "false",
                "Authorization": "Bearer " + user.token
            };

            const res = await axios.post(
                "https://api.heryerdeingilizce.com/api/user/Opt/UpdateFullName",
                {
                    fullName: document.getElementById("name").value
                },
                { headers: headerss }
            );

            if (res.status === 200 && res.data.success) {
                Swal.fire({
                    title: "Başarılı",
                    text: "Adınız ve soyadınız başarıyla değiştirildi.",
                    icon: "success",
                    confirmButtonText: "Tamam"
                });
                console.log()
            } else {
                Swal.fire({
                    title: t("error"),
                    text: res.data.message,
                    icon: "error",
                    confirmButtonText: "Tamam"
                });
            }
        } catch (err) {
            console.log();
        }
    }

    return (
        <div className="container my-5">
            <div className="row justify-content-center">
                <div className="col-md-6">

                    <div className="card shadow-sm">
                        <div className="card-body">

                            <h3 className="text-center mb-4">
                                {t("profile")}
                            </h3>

                            <form onSubmit={handleSubmit}>

                                <div className="mb-3">
                                    <label
                                        htmlFor="name"
                                        className="form-label"
                                    >
                                        {t("namesurname")}
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="name"
                                        defaultValue={user.user.fullName}
                                    />
                                </div>



                                <div className="d-grid">
                                    <button
                                        type="submit"
                                        className="btn btn-primary btn-lg"
                                    >
                                        {t("update")}
                                    </button>
                                </div>

                            </form>





                        </div>
                    </div>

                    <hr className="mt-4" />
                    <h6 className="text-center mt-4 text-muted"> Hesabınızın geçerlilik süresi: <br />
                        {user.user.expiryDate ? ` ${new Date(user.user.expiryDate).toLocaleDateString()} tarihine kadar geçerlidir.` : ""}
                    </h6>
                </div>
            </div>
        </div >
    );
};

export default GeneralProfile;
